import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "./TaskAssign.css";
import Navbar from "../../Navbar/Navbar";
import { empList } from "../../../Redux/DailyUpdateApproval/Action";
import { useDispatch, useSelector } from "react-redux";
import { endOfMonth, format, startOfMonth } from "date-fns";

import {
  getProjectMaster,
  getTaskDetails,
  gettaskMasterListForAssign,
  gettaskpriority,
  getTaskReportEmployeeWise,
  gettaskstatus,
  gettasktype,
  getcreateTask,
} from "../../../Redux/Task/Action";
import { FaEdit } from "react-icons/fa";
import Swal from "sweetalert2";
import NewGlobalDataTable from "../../DataTable/NewGlobalDataTable";
import Icon from "../../utility/Icon";

const TaskAssign = () => {
  const token = localStorage.getItem("token");
  const loginId = localStorage.getItem("loginId");
  const dispatch = useDispatch();
  const { emplists } = useSelector((store) => store.dailyUpdateApprover);
  const [fromDate, setFromDate] = useState(startOfMonth(new Date()));
  const [toDate, setToDate] = useState(endOfMonth(new Date()));
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [onEditing, setonEditing] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const {
    getprojectDropdownData,
    taskReport,
    taskAssignList,
    taskEdit,
    taskType,
    taskPriority,
    taskStatus,
  } = useSelector((store) => store.task);

  emplists.map((emp) => ({
    value: emp.loginId,
    label: `${emp.firstName} ${emp.lastName}`,
    empId: emp.loginId,
  }));

  const [task, setTask] = useState({
    projectCode: "",
    module: "",
    title: "",
    type: "",
    startDate: "",
    endDate: "",
    effortReq: 0,
    effortActual: 0,
    priorityCode: "",
    assignId: "",
    status: "",
    taskDesc: "",
    remark: "",
    actionType: "INSERT",
    initiatorId: loginId,
    hrmsTaskMasterId: "",
  });

  useEffect(() => {
    if (taskEdit) {
      setTask((prevData) => ({
        ...prevData,
        projectCode: taskEdit.projectCode,
        module: taskEdit.module,
        title: taskEdit.title,
        type: taskEdit.type,
        startDate: taskEdit.startDate,
        endDate: taskEdit.endDate,
        effortReq: taskEdit.effortReq,
        effortActual: taskEdit.effortActual,
        priorityCode: taskEdit.priorityCode,
        assignId: taskEdit.ownerShipId,
        status: taskEdit.status,
        taskDesc: taskEdit.taskDesc,
        hrmsTaskMasterId: taskEdit.hrmsTaskMasterId,
        actionType: "UPDATE",
      }));
    }
  }, [taskEdit]);

  useEffect(() => {
    dispatch(empList(token));
    dispatch(getProjectMaster(token));
    dispatch(gettaskpriority(token));
    dispatch(gettaskstatus(token));
    dispatch(gettasktype(token));
  }, [dispatch, token]);

  useEffect(() => {
    dispatch(gettaskMasterListForAssign(token,pageNumber-1,pageSize));
  }, [dispatch, token, pageNumber, pageSize]);

  const handleTaskInputChange = (e) => {
    const { name, value } = e.target;
    if (value && /^[\s]/.test(value)) {
      e.preventDefault();
      return;
    }
 
    if (name === "effortReq" || name === "effortActual") {
      const numericValue = value === "" ? 0 : value;

      if (/^(0|[1-9]\d*)?$/.test(numericValue)) {
        setTask({ ...task, [name]: numericValue });
      }
    } else if (name === "endDate" && task.startDate) {
      const startDate = new Date(task.startDate);
      const endDate = new Date(value);

      if (endDate < startDate) {
        alert("End Date must be after Start Date.");
        return; // Prevent setting the invalid end date
      }
      setTask({ ...task, [name]: value });
    } else {
      setTask({ ...task, [name]: value });
    }
  };

  const handleFromDateChange = (value) => {
    const newFromDate = new Date(value);
    setFromDate(newFromDate);
    if (newFromDate > toDate) {
      setToDate(newFromDate);
      alert("The From Date should be earlier than or equal to the To Date.");
    }
  };
  const handleToDateChange = (value) => {
    const newToDate = new Date(value);
    setToDate(newToDate);
    if (fromDate > newToDate) {
      alert("The From Date should be earlier than or equal to the To Date.");
    }
  };

   const handleDateChangeForTaskIput = (date, name) => {
  if (name === "endDate" && task.startDate) {
    const startDate = new Date(task.startDate);

    if (date < startDate) {
      alert("End Date must be after Start Date.");
      return;
    }
  }
  setTask({ ...task, [name]: date });
};

  const handelfetchTaskDetails = (e) => {
    dispatch(getTaskDetails(e.hrmsTaskMasterId, token));
    setonEditing(true);
    setShow(true);
  };

  const handleEmpChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedEmployee(selectedValue);
    dispatch(
      getTaskReportEmployeeWise(
        selectedValue,
        format(fromDate, "yyyy-MM-dd"),
        format(toDate, "yyyy-MM-dd"),
        token
      )
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const taskData = {
      ...task,
      effortActual: task.effortActual || 0,
      effortReq: task.effortReq || 0,
    };
    Swal.fire({
      title: "Are you sure?",
      html: `Do you want to submit the task details?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
      cancelButtonText: "No, cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        // dispatch(getcreateTask(taskToSubmit, token))
        dispatch(getcreateTask(taskData, token))
          .then(({ success }) => {
            if (success) {
              handleClose();
              dispatch(gettaskMasterListForAssign(token,pageNumber-1,pageSize));
              Swal.fire({
                icon: "success",
                title: "Success!",
                text: "Task details submitted successfully.",
                timer: 4000,
                showConfirmButton: false,
              });
            } else {
              Swal.fire({
                title: "Error!",
                text: "There was an error submitting the task details.",
                icon: "error",
                confirmButtonText: "OK",
              });
            }
          })
          .catch(() => {
            Swal.fire({
              title: "Error!",
              text: "There was an error in catch submitting the task details.",
              icon: "error",
              timer: 5000,
              confirmButtonText: "OK",
            });
          });
      }
    });
  };

  const Tooltip = ({ text, children }) => {
    return (
      <div className="tooltip-container">
        {children}
        <div className="tooltip">{text}</div>
      </div>
    );
  };

  const columns = [
    {
      name: "ProjectCode",
      selector: (row) => row.projectCode,
      sortable: true,
    },
    {
      name: "Date Range",
      selector: (row) => (
        <div>
          {row.startDate} <br />
          {row.endDate}
        </div>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Ownership",
      selector: (row) => row.ownershipName,
      sortable: true,
    },
    {
      name: "Assign To",
      selector: (row) => row.assignName || '-',
      sortable: true,
    },

    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
    },
    {
      name: "Task Title",
      selector: (row) => row.title,
      sortable: true,
    },

    {
      name: "Effort Request",
      selector: (row) => row.effortReq,
      sortable: true,
    },
    {
      name: "Action",
      selector: (row) => row,
      sortable: true,
      cell: (row) => (
        <div>
               <Icon
            icon={FaEdit}
            variant="warning"
            title="Edit"
            onClick={() => handelfetchTaskDetails(row)}
          />
      
        </div>
      ),
    },
  ];

  return (
    <div>
      <Navbar></Navbar>
        <div className="main-content">
      <div className="container-fluid mt-4">
        <div>
          <div className="row mb-3 justify-content-end align-items-center">
            <div className="col-auto d-flex align-items-center mb-2 mb-sm-0">
              <b>
                <label className="custom-label">Employee :</label>
              </b>
            </div>
            <div className="col-sm-4">
              <select
                name="assignId"
                value={selectedEmployee}
                onChange={handleEmpChange}
                id="assignId"
                className="form-select"
              >
                <option value="">Choose Option...</option>
                {emplists.map((emp, index) => (
                  <option key={index} value={emp.loginId}>
                    {emp.firstName} {emp.lastName}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-auto d-flex align-items-center mb-2 mb-sm-0">
              <b>
                <label className="custom-label">From Date :</label>
              </b>
            </div>
            <div className="col-auto d-flex align-items-center mb-2 mb-sm-0">
                <DatePicker
                  selected={fromDate}
                  onChange={(newValue) => {
                    handleFromDateChange(newValue);
                  }}
                  className="form-control"
                  dateFormat="dd-MM-yyyy"
                  showYearDropdown
                  showMonthDropdown
                  dropdownMode="select"
                  onKeyDown={(event) => event.preventDefault()}
                />
            </div>
            <div className="col-auto d-flex align-items-center mb-2 mb-sm-0">
              <b>
                <label className="custom-label">To Date :</label>
              </b>
            </div>
            <div className="col-auto d-flex align-items-center mb-2 mb-sm-0">
               <DatePicker
                  selected={toDate}
                  onChange={(newValue) => {
                    handleToDateChange(newValue);
                  }}
                  className="form-control"
                  dateFormat="dd-MM-yyyy"
                  showYearDropdown
                  showMonthDropdown
                  minDate={fromDate}
                  dropdownMode="select"
                  onKeyDown={(event) => event.preventDefault()}
                />
            </div>
          </div>

          <div className="card3" id="card3">
            <div className="card-body">
              <div className="d-flex bd-highlight">
                <div className="container">
                  <div className="row my-2 mx-3">
                    <div className="col border bg-info text-white py-2">
                      Name
                    </div>
                    <div className="col border py-2">{taskReport.empName}</div>
                    <div className="col border bg-info text-white py-2">
                      No of Task
                    </div>
                    <div className="col border py-2">{taskReport.noOfTask}</div>
                    <div className="col border bg-info text-white py-2 ">
                      TotalEffort
                    </div>
                    <div className="col border py-2">
                      {taskReport.totalEffort}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


     
      
        <NewGlobalDataTable
   columns={columns} 
   data={taskAssignList.taskMaster} 
   tableName={'TASK ASSIGN'} 
   setPageSize={setPageSize} 
   setPageNumber={setPageNumber}
   totalRecord={taskAssignList.totalRecord}
/>


          {/* this is create task modal */}
          {show && <div className="modal-backdrop fade show"></div>}

          <div
            className={`modal fade ${show ? "show d-block" : ""}`}
            tabIndex="-1"
            role="dialog"
          >
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    {onEditing ? "Update Task Deatils" : "Add Task Details"}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={handleClose}
                  ></button>
                </div>
                <div className="modal-body">
                  {/*---------------------------- form inputs--------------- */}
                  <form onSubmit={handleSubmit}>
                    <div className="row g-3">
                      <div className="col-md-6">
                        <label htmlFor="projectCode" className="form-label">
                          Project
                        </label>
                        <select
                          name="projectCode"
                          value={task.projectCode || ""}
                          onChange={handleTaskInputChange}
                          id="projectCode"
                          className="form-select"
                          required
                        >
                          <option value="">Choose Option...</option>
                          {getprojectDropdownData.map((projectCode) => (
                            <option
                              key={projectCode.projectMasterId}
                              value={projectCode.projectCode}
                            >
                              {projectCode.projectName}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="col-md-6">
                        <label htmlFor="module" className="form-label">
                          Module
                        </label>
                        <input
                          type="text"
                          name="module"
                          value={task.module || ""}
                          onChange={handleTaskInputChange}
                          className="form-control"
                          id="module"
                          required
                        />
                      </div>
                    </div>
                    {/*---------------------------- Line 2--------------- */}
                    <div className="row g-3">
                      <div className="col-md-12">
                        <label htmlFor="title" className="form-label">
                          Task Title
                        </label>
                        <input
                          type="text"
                          name="title"
                          value={task.title || ""}
                          onChange={handleTaskInputChange}
                          className="form-control"
                          id="title"
                          placeholder="Enter Task Title.."
                          required
                        />
                      </div>
                    </div>
                    {/*---------------------------- Line 3--------------- */}
                    <div className="row g-3">
                      <div className="col-md-4">
                        <label htmlFor="startDate" className="form-label">
                          Start Date
                        </label>
                          <DatePicker
                            selected={task.startDate || ""}
                            onChange={(newValue) => {
                              handleDateChangeForTaskIput(newValue, "startDate");
                            }}
                            className="form-control"
                            dateFormat="dd-MM-yyyy"
                            showYearDropdown
                            showMonthDropdown
                            dropdownMode="select"
                            onKeyDown={(event) => event.preventDefault()}
                          />
                      </div>
                      <div className="col-md-4">
                        <label htmlFor="endDate" className="form-label">
                          End Date
                        </label>
                          <DatePicker
                            selected={task.endDate || ""}
                            onChange={(newValue) => {
                              handleDateChangeForTaskIput(newValue, "endDate");
                            }}
                            className="form-control"
                            dateFormat="dd-MM-yyyy"
                            showYearDropdown
                            showMonthDropdown
                            dropdownMode="select"
                            onKeyDown={(event) => event.preventDefault()}
                            minDate={task.startDate}
                          />
                      </div>
                      <div className="col-md-4">
                        <label htmlFor="type" className="form-label">
                          Type
                        </label>
                        <select
                          name="type"
                          value={task.type || ""}
                          onChange={handleTaskInputChange}
                          id="type"
                          className="form-select"
                          required
                        >
                          <option value="">Choose Option...</option>
                          {taskType &&
                            taskType.map((task, index) => (
                              <option key={index} value={task.ticketTypeId}>
                                {task.ticketType}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    {/*---------------------------- Line 4--------------- */}
                    <div className="row g-3">
                      <div className="col-md-4">
                        <label htmlFor="effortReq" className="form-label">
                          Effort Request
                        </label>
                        <input
                          type="number"
                          name="effortReq"
                          value={task.effortReq || ""}
                          onChange={handleTaskInputChange}
                          className="form-control"
                          id="effortReq"
                          required
                        />
                      </div>
                      <div className="col-md-4">
                        <label htmlFor="effortActual" className="form-label">
                          Effort Actual
                        </label>
                        <input
                          type="number"
                          name="effortActual"
                          value={task.effortActual || ""}
                          onChange={handleTaskInputChange}
                          className="form-control"
                          id="effortActual"
                        />
                      </div>
                      <div className="col-md-4">
                        <label htmlFor="priorityCode" className="form-label">
                          Priority
                        </label>
                        <select
                          name="priorityCode"
                          value={task.priorityCode || ""}
                          onChange={handleTaskInputChange}
                          id="priorityCode"
                          className="form-select"
                          required
                        >
                          <option value="">Choose Option...</option>
                          {taskPriority &&
                            taskPriority.map((task) => (
                              <option
                                key={task.priorityId}
                                value={task.priorityCode}
                              >
                                {task.priorityName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    {/*---------------------------- Line 5--------------- */}
                    <div className="row g-3">
                      <div className="col-md-8">
                        <label htmlFor="assignId" className="form-label">
                          Ownership To
                        </label>
                        <select
                          name="assignId"
                          value={task.assignId || ""}
                          onChange={handleEmpChange}
                          id="assignId"
                          className="form-select"
                          required
                          disabled={onEditing}
                        >
                          <option value="">Choose Option...</option>
                          {emplists.map((emp, index) => (
                            <option key={index} value={emp.loginId}>
                              {emp.firstName} {emp.lastName}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-4">
                        <label htmlFor="status" className="form-label">
                          Status
                        </label>
                        <select
                          name="status"
                          value={task.status || ""}
                          onChange={handleTaskInputChange}
                          id="status"
                          className="form-select"
                          required
                        >
                          <option value="">Choose Option...</option>
                          {taskStatus &&
                            taskStatus.map((task) => (
                              <option
                                key={task.ticketStatusId}
                                value={task.status}
                              >
                                {task.description}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="row g-3">
                      <div className="form-group mb-3">
                        <label className="form-label" htmlFor="taskDesc">
                          Description
                        </label>
                        <textarea
                          className="form-control"
                          name="taskDesc"
                          value={task.taskDesc || ""}
                          onChange={handleTaskInputChange}
                          id="taskDesc"
                          required
                        ></textarea>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col text-center mt-3">
                        <button type="submit" className="btn btn-primary">
                          {onEditing ? "UPDATE" : "SUBMIT"}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
};

export default TaskAssign;
